import { useQueryClient } from "@tanstack/react-query";
import useAPI, { useAPIMutation } from "@/services/api/hook";
import { ExtendedUseQueryResult } from "@/services/api/types";
import {
  TokenStatusResponse,
  TokenCreateInput,
  TokenCreateResponse
} from "@/entities/pat/types";

export const useMyPat = (): ExtendedUseQueryResult<TokenStatusResponse> => {
  return useAPI("pat/me");
};

export const useCreatePat = () => {
  const queryClient = useQueryClient();
  return useAPIMutation<TokenCreateInput, TokenCreateResponse>(
    "pat/create",
    { method: "POST" },
    () => {
      queryClient.invalidateQueries({ queryKey: ["pat/me"] });
    }
  );
};

export const useDeletePat = () => {
  const queryClient = useQueryClient();
  return useAPIMutation<
    { pathParams: { tokenId: string } },
    { deleted: boolean }
  >(
    "pat/delete",
    { method: "DELETE" },
    () => {
      queryClient.invalidateQueries({ queryKey: ["pat/me"] });
    }
  );
};
